// extracted by mini-css-extract-plugin
var _1 = "AttributeTagSection-module__automationApprovedTag___Nh_2u";
var _2 = "AttributeTagSection-module__automationTag___o5qUS";
var _3 = "AttributeTagSection-module__overrideEnabledTag___gJN4V";
export { _1 as "automationApprovedTag", _2 as "automationTag", _3 as "overrideEnabledTag" }
